// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--2R8Y7","sideTitle":"Card-module--sideTitle--fUahQ"};